$(window).on('load resize', function() {
  $('#insta-feed').css({'height': $('#insta-feed img').eq(0).height() });
})

var preloadImgs = [];

$(document).ready(function(){
  

  $(".animsition").animsition({
    inClass: 'fade-in',
    outClass: 'fade-out',
    inDuration: 300,
    outDuration: 200,
    linkElement: '.animsition-link',
    // e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
    loading: true,
    loadingParentElement: 'body', //animsition wrapper element
    loadingClass: 'animsition-loading',
    loadingInner: '<img src="https://cdn.shopify.com/s/files/1/2596/9788/files/loading_gif_src.gif?10810382395641901510" />', // e.g '<img src="loading.svg" />'
    timeout: false,
    timeoutCountdown: 5000,
    onLoadEvent: true,
    browser: [ 'animation-duration', '-webkit-animation-duration'],
    // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
    // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
    overlay : false,
    overlayClass : 'animsition-overlay-slide',
    overlayParentElement : 'body',
    transition: function(url){ window.location.href = url; }
  });
  
  
  if ($('#add-a-gift-enclosure-card').length) {
    
    $('#add-a-gift-enclosure-card input[type=checkbox]').change(function() {
    	if(this.checked) {
    	   $('#gift-enclosure-card-message').slideDown();
    	} else {
          $('#gift-enclosure-card-message').slideUp(400, function() {
			   $('textarea', this).val('');
			});
    	}      
	})
 
  }
  
  
	$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})
    
    $(".product-inner>figure").mouseover(function () {  //console.log('hover image: ' + $('figure', this).data("src-hover") );
      $(this).css({'background-image': 'url(' + $(this).data("src-hover") + ')' });
	}).mouseout(function () {
      $(this).css({'background-image' : 'url(' + $(this).data("src-img") + ')' });
	});
    
  	$(".product-inner>figure").each(function() {
        var img = new Image();
        img.src = $(this).data("src-hover");
        preloadImgs.push(img);
    });
  
  $(".collection-tools-center").each(function(){        
    if($(this).find('.subnav').is(":empty")){
      $(this).addClass("hide");
    }
  });
  
  
});



$("body").on("productOptionsLoaded", function(containerDiv) {
  
	if ($('.product-options-radiobutton').length) {
      
		initiateEngravingForm();
      
    }
  
});

function initiateEngravingForm() {

	var $radios = $('input.product-options-radiobutton:radio');
	if($radios.is(':checked') === false) {
		$radios.filter('[value=None]').prop('checked', true);
          $('.engraving-entry input.product-options-textbox, .engraving-entry textarea.product-options-textarea').val('').removeClass("serif script").prop("disabled", true);
	}
  
  	$('input.product-options-radiobutton:radio').on('change', function() {
        
        if ($(this).val()=="None") {
          	$('.engraving-entry input.product-options-textbox, .engraving-entry textarea.product-options-textarea').val('').removeClass("serif script").prop("disabled", true);
			$('.product-options-errors, .engraving-entry').hide();
        } else {
          $('.engraving-entry').show();
          $('.engraving-entry input.product-options-textbox, .engraving-entry textarea.product-options-textarea').prop("disabled", false).removeClass("serif script").addClass( $(this).val().toLowerCase() );
          $('.product-options-textbox').eq(0).focus();
        }
        
      })
      
	$('.engraving-entry input.product-options-textbox, .engraving-entry textarea.product-options-textarea').on("keyup", function(e) {
      	$('.product-options-errors').hide();
      	
	});    	
  
}

// Don't remove
$("body").on("productOptionsLoaded", function(containerDiv) {
  initiateEngravingFormCustom();
});

function initiateEngravingFormCustom() {
  $(".image-picker-item").each(function( index ) {    
    $(this).on('click touchstart', function() {  
      if($(this).hasClass('imagepicker-selected')){
        var curVal = $(this).attr('data-name').toLowerCase();
        if($('.engraving-entry').hasClass('script') || $('.engraving-entry').hasClass('serif') || $('.engraving-entry').hasClass('none')) {
          $('.engraving-entry').removeClass('script');
          $('.engraving-entry').removeClass('serif');
          $('.engraving-entry').removeClass('none');
        }        
          $('.engraving-entry').addClass(curVal);        
      }
    });    
  });
}


    $(document).on('input propertychange','.engraving-entry input.product-options-textbox',function(e){
      if ( $(this).parent().hasClass('limit12') ) {
        var LINE_LENGTH_CHARS = 12;
      } else if( $(this).parent().hasClass('limit9') ) {
        var LINE_LENGTH_CHARS = 9;
      } else if( $(this).parent().hasClass('limit8') ) {
        var LINE_LENGTH_CHARS = 8;
      } else if( $(this).parent('.engraving-entry').hasClass('limit3') ) {
        var LINE_LENGTH_CHARS = 8;
      }
      
      //console.log('limit: ' + LINE_LENGTH_CHARS);
        $actualCharCount = $(this).val().length; //$(this).val().replace(/\s+/g, '').length;
      
      	//console.log( $actualCharCount );
      
      	if ( $actualCharCount >= LINE_LENGTH_CHARS+1 ) {
          	deleteLastCharacter( $(this) );
      	}
      
    });

function deleteLastCharacter($input) {

  	$input.val(
    function(index, value){
        return value.substr(0, value.length - 1);
	})

}
$(document).ready(function(){
  // sticky nav + popup
  
  var stickyNavTop = $('.section-header').offset().top;
  var stickyNav = function() {
    var scrollTop = $(window).scrollTop();
    if (scrollTop > stickyNavTop) {
      $('.section-header').addClass('sticky');
      //$('main').css('margin-top', '123px');
    } else {
      $('.section-header').removeClass('sticky');
      $('main').css('margin-top', 'initial');
    }
  };
  $(window).on('resize scroll', function() {
  stickyNav();
  });
});
$(window).on('resize scroll', function() {
  var scrolling = $(window).scrollTop();
  var winHeight = $(window).height();
  //stickyNav();
  if (scrolling > 400) {
    $('.hero .logo').css({
      'display': 'none'
    })
  } else {
    $('.hero .logo').css({
      'display': 'block'
    })
  }

  if (scrolling > (winHeight + 400)) {
    $('.hero').css({
      'visibility': 'hidden'
    })
  } else {
    $('.hero').css({
      'visibility': 'visible'
    })
  }	

});


$(function($) {
  var myFunc = function () {
    var w = document.body.clientWidth;
    if(w>= 720)
    {
      var divheight = $('#shopify-section-header').outerHeight();
      $('.showcase, .product-details-wrapper .module.header').css('top', divheight);
    }
    else {
      $('.showcase, .product-details-wrapper .module.header').css('top', 'auto');
    }
  }
  setTimeout(function(){ myFunc(); }, 500);   //remove this if you don't want it called on initial load
  jQuery(window).bind('resize orientationchange', myFunc);
  /* Close mobile menu */
  $('.closemenu_mobile').click(function(e){
    $('.mobile_menu').trigger("click");
  });
});

$(function() {
  $(".dropdown-wrap1 .dropdown-item").each(function() {      
    if ($(this).hasClass('link-active')) {
      $(this).closest('.nav-item').find('.parent').addClass('active');
    }
  });
});